<template>
  <v-dialog 
    v-model="showDialog" 
    max-width="800px"
    @click:outside="cancel"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Editar Elemento</span>
      </v-card-title>
      <v-card-text>
        <v-textarea
          v-model="content"
          label="Contenido"
          auto-grow
          rows="10"
          outlined
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cancel">Cancelar</v-btn>
        <v-btn color="blue darken-1" text @click="saveContent">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditingElement",
  props: {
    value: Boolean,  // Controla la visibilidad
    element: Object, // Recibe el elemento a editar
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      },
    },
    updatedElement() {
      return { ...this.element, description: this.content, blocked: false };
    },
  },
  data() {
    return {
      content: "",
    };
  },
  watch: {
    element: {
      immediate: true, // Se ejecuta cuando `element` cambia
      handler(newElement) {
        this.content = newElement?.description || "";
      },
    },
  },
  methods: {
    saveContent() {
      this.$emit("save", this.updatedElement);
      this.closeDialog();
    },
    closeDialog() {
      this.$emit("update:value", false); // Cierra el diálogo desde el padre
    },
    cancel() {
      this.$emit("cancelEditingElement");
      this.closeDialog();
    }
  },
};
</script>
